import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectedDialogDirective } from './connected-dialog.directive';
import { ConnectedDialogService } from './connected-dialog.service';



@NgModule({
  declarations: [
    ConnectedDialogDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ConnectedDialogDirective
  ],
  providers: [
    ConnectedDialogService
  ]
})
export class ConnectedDialogModule { }
